import React from "react";

function Menu() {
  return (
    <div className="mm-menu">
      <div className="mm-menu__wrapper">
        <menu className="mm-menu__list">
          <a
            href="https://travelhub.moscow/moscowmasters/#about"
            className="mm-menu__list-item"
          >
            О конкурсе
          </a>
          <a
            href="https://travelhub.moscow/moscowmasters/#form"
            className="mm-menu__list-item"
          >
            Заявка
          </a>
          <a
            href="https://travelhub.moscow/moscowmasters/#partners"
            className="mm-menu__list-item"
          >
            партнёры
          </a>
          <a
            href="https://travelhub.moscow/moscowmasters/#jury"
            className="mm-menu__list-item"
          >
            Экспертное жюри
          </a>
          <a
            href="https://travelhub.moscow/moscowmasters/#contacts"
            className="mm-menu__list-item"
          >
            Контакты
          </a>
        </menu>
        <div className="mm-menu-logos">
          <a
            href="https://www.mos.ru/tourism/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={process.env.PUBLIC_URL + "/img/comitee-logo.svg"}
              alt=""
              className="mm-menu_logo"
            />
          </a>
          <a href="https://toursport.pro/" target="_blank" rel="noreferrer">
            <img
              src={process.env.PUBLIC_URL + "/img/mosprofsport.png"}
              alt=""
              className="mm-menu_logo"
            />
          </a>
          <a href="https://mkppr.rspp.ru/" target="_blank" rel="noreferrer">
            <img
              src={process.env.PUBLIC_URL + "/img/rspp.png"}
              alt=""
              className="mm-menu_logo"
            />
          </a>
        </div>
        <div className="mm-menu__burger">
          <svg
            width="32"
            height="19"
            viewBox="0 0 32 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="3" fill="black" />
            <rect y="8" width="32" height="3" fill="black" />
            <rect y="16" width="32" height="3" fill="black" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Menu;
